<template>
  <div>
    <b-input-group prepend="Chargé d'affaire"
                   :id="getId()"
                   class="">
      <b-form-select v-model="selected" :id="`form-${getId()}`" @input="allocateCaseManager($event)">
        <option :value="null">Aucun</option>
        <option v-for="(caseManager, index) in caseManagers" :value="caseManager.id" :key="index">
          {{ formatCaseManagerName(caseManager) }}
        </option>
      </b-form-select>
    </b-input-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Clone from 'clone';

import CaseManagerService from '../../../services/CaseManagerService';

export default {
  name: 'SelectCaseManager',
  props: {
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    ...mapGetters([
    ]),
    caseManagers() {
      if (this.getCaseManagerList() === null || typeof this.getCaseManagerList() === 'undefined') {
        return [];
      }
      let caseManagerList = Clone(this.getCaseManagerList());
      caseManagerList = caseManagerList.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
      });
      return caseManagerList;
    },
  },
  methods: {
    ...mapGetters([
      'getCaseManagerList',
    ]),
    formatCaseManagerName(caseManager) {
      return CaseManagerService.formatName(caseManager);
    },
    getId() {
      return `select-case-manager-${this._uid}`;
    },
    allocateCaseManager(selected) {
      // Emit event with case manager id
      this.$emit('allocateCaseManager', selected);
    },
  },
  mounted() {
    if (typeof this.getCaseManagerList() === 'undefined' || this.getCaseManagerList() === null) {
      this.$store.dispatch('getCaseManagers').finally();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/select/SelectCaseManager.vue